import { createContext } from 'preact';

export const SlotContext = createContext({ fills: [] });
